import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { Logo } from "@/components/Logo";

const COLS = [
  { h: "Platform", l: [["AI Marketing Capabilities", "/platform"], ["Content Studio", "/platform#content-studio"], ["Content Calendar", "/platform#content-calendar"], ["Campaign Planning", "/platform#campaign-planning"], ["Analytics", "/platform#analytics"], ["Integrations", "/integrations"]] },
  { h: "Explore", l: [["Product Tour", "/tour"], ["Sample Outputs", "/tour#samples"], ["Pricing", "/pricing"], ["AI Credits", "/pricing#credits"], ["Resources", "/resources"]] },
  { h: "Company", l: [["About Sliance", "/about"], ["Contact", "/contact"], ["Careers", "/contact?topic=Careers"]] },
  { h: "Legal", l: [["Privacy Policy", "/legal/privacy"], ["Terms of Service", "/legal/terms"], ["Cookie Policy", "/legal/cookies"], ["Refund & Cancellation", "/legal/refund"], ["AI Usage Policy", "/legal/ai-usage"], ["GDPR & Data Protection", "/legal/gdpr"]] },
  { h: "Account", l: [["Log In", "/login"], ["Create Account", "/register"], ["Billing & Support", "/app/billing"]] },
];

export const Footer = () => (
  <footer className="relative border-t bg-card/40" data-testid="site-footer">
    <div className="container-x py-16 grid gap-12 lg:grid-cols-12">
      <div className="lg:col-span-4 space-y-5">
        <Logo className="h-9 text-foreground" testId="footer-logo" />
        <p className="text-sm text-muted-foreground max-w-sm leading-relaxed">
          Sliance helps businesses plan, create, organize, and improve their marketing with AI-assisted workflows. Feature availability depends on your plan and connected services.
        </p>
        <div className="space-y-1.5 text-sm">
          {[["Enquiries", "contact@sliance.com"], ["Support", "support@sliance.com"], ["Privacy & legal", "legal@sliance.com"]].map(([l, e]) => (
            <a key={e} href={`mailto:${e}`} data-testid={`footer-email-${l.split(" ")[0].toLowerCase()}`} className="flex items-center gap-2 font-medium text-[#7c3aed] dark:text-[#a78bfa]"><Mail className="h-4 w-4" /> <span className="text-muted-foreground w-28">{l}</span>{e}</a>
          ))}
        </div>
      </div>
      <div className="lg:col-span-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-8">
        {COLS.map((c) => (
          <div key={c.h}>
            <div className="eyebrow mb-4">{c.h}</div>
            <ul className="space-y-2.5">
              {c.l.map(([t, to]) => (
                <li key={t}><Link to={to} className="text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid={`footer-link-${t.toLowerCase().replace(/[^a-z]+/g, "-")}`}>{t}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
    <div className="border-t">
      <div className="container-x py-6 flex flex-col sm:flex-row gap-2 justify-between text-xs text-muted-foreground">
        <span>© {new Date().getFullYear()} Cognitive Market Intelligence Pvt. Ltd. (Sliance) · GSTIN 22AAICC0720A1ZN. All rights reserved.</span>
        <span>No guarantee of specific marketing results. GDPR-aligned data handling.</span>
      </div>
    </div>
  </footer>
);
